import useDialog from './use-dialog';

export { useDialog };

export default useDialog;
